// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dragdrop {
    width: 100%;
    height: 25%;
    min-height: 200px;
    min-width: 300px;
    padding: 2rem;
    text-align: center;
    border: dashed 1px #979797;
    position: relative;
    justify-content: center;
    border-radius: 1pc;
}

.dragdroptext {
    display: flex;
    justify-content: center;
    margin-top: 4px;
    text-align: left;
    text-align: center;
    font: normal normal normal 20px/25px Segoe UI;
    color: var(--integration-light-text-color);
    opacity: 1;
}

.center {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    margin-top: 20px;
}

.dragdrop-icon {
    height: 64px;
    width: 64px;
    max-width: 100%;
    max-height: 100%;
    margin-top: 15px;
}

.cickable {
    cursor: pointer;
}

.browsebtn {
    border-radius: 6px;
    border: 1px solid #D1D5DB;
    height: 100px;
    width: 180px;
    background-color: var(--integration-background);
    padding: 10px 16px;
    margin-top: 18px;
    align-items: center;
    font: normal normal normal 20px/20px Segoe UI;
    letter-spacing: 0.22px;
    color: var(--integration-text-color);
    opacity: 1;
    cursor: pointer;
}

    .browsebtn:hover{
        background-color: var(--integration-hover-background);
    }

input {
    opacity: 0;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.upload-file {
    display: grid;
    justify-content: flex-start;
}

.file-item {
    border: solid 1px black;
    border-radius: 5px;
    width: 200px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.horizontal {
    display: flex;
    width: 100%;
    overflow: hidden;
}

.file-item .filename {
    white-space: nowrap;
    overflow: hidden;
    width: 150px; /* Adjust width to your needs */
}

    .file-item .filename.scroll {
        animation: scroll 5s linear infinite; /* Adjust 5s to control speed */
    }

@keyframes scroll {
    0% {
        transform: translateX(0);
    }

    100% {
        transform: translateX(-100%);
    }
}


.fileicon {
    height: 20px;
    width: 20px;
}

.uploadRadioBtn {
    margin-top: 20px;
    margin-left: 10px;
    color: var(--integration-color);
}

.hasHeadersHeader {
    margin-top: 20px;
    font: normal normal bold 15px/20px Segoe UI;
    letter-spacing: 1px;
    color: #0F3443;
    opacity: 1;
}

.hasHeadersSubHeader {
    margin-top: 6px;
    font: normal normal 600 15px/20px Segoe UI;
    color: var(--integration-light-text-color);
    opacity: 1;
}

.radioBtnLabel {
    font: normal normal bold 15px/20px Segoe UI;
    letter-spacing: 1px;
    color: #0F3443;
    opacity: 1;
}

.uploadFileName {
    margin-top: 15px;
    font: normal normal 600 18px/20px Segoe UI;
    opacity: 1;
    color: #374151;
    margin-bottom: 10px;
}

.uploadOptionsBoxHeader {
    font: normal normal 600 15px/20px Segoe UI;
    opacity: 1;
    color: #374151;
    margin-top: 10px;
}

.uploadOptionsBox {
    width: 216px;
    height: 37px;
    margin-right: 40px;
    
}`, "",{"version":3,"sources":["webpack://./src/app/integration/integrationwizard/iw.upload.page.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,6CAA6C;IAC7C,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,6CAA6C;IAC7C,sBAAsB;IACtB,oCAAoC;IACpC,UAAU;IACV,eAAe;AACnB;;IAEI;QACI,qDAAqD;IACzD;;AAEJ;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,YAAY,EAAE,+BAA+B;AACjD;;IAEI;QACI,oCAAoC,EAAE,+BAA+B;IACzE;;AAEJ;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;;AAGA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,UAAU;AACd;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,UAAU;IACV,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;;AAEtB","sourcesContent":[".dragdrop {\n    width: 100%;\n    height: 25%;\n    min-height: 200px;\n    min-width: 300px;\n    padding: 2rem;\n    text-align: center;\n    border: dashed 1px #979797;\n    position: relative;\n    justify-content: center;\n    border-radius: 1pc;\n}\n\n.dragdroptext {\n    display: flex;\n    justify-content: center;\n    margin-top: 4px;\n    text-align: left;\n    text-align: center;\n    font: normal normal normal 20px/25px Segoe UI;\n    color: var(--integration-light-text-color);\n    opacity: 1;\n}\n\n.center {\n    display: flex;\n    justify-content: center;\n    margin: 0 auto;\n    margin-top: 20px;\n}\n\n.dragdrop-icon {\n    height: 64px;\n    width: 64px;\n    max-width: 100%;\n    max-height: 100%;\n    margin-top: 15px;\n}\n\n.cickable {\n    cursor: pointer;\n}\n\n.browsebtn {\n    border-radius: 6px;\n    border: 1px solid #D1D5DB;\n    height: 100px;\n    width: 180px;\n    background-color: var(--integration-background);\n    padding: 10px 16px;\n    margin-top: 18px;\n    align-items: center;\n    font: normal normal normal 20px/20px Segoe UI;\n    letter-spacing: 0.22px;\n    color: var(--integration-text-color);\n    opacity: 1;\n    cursor: pointer;\n}\n\n    .browsebtn:hover{\n        background-color: var(--integration-hover-background);\n    }\n\ninput {\n    opacity: 0;\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n\n.upload-file {\n    display: grid;\n    justify-content: flex-start;\n}\n\n.file-item {\n    border: solid 1px black;\n    border-radius: 5px;\n    width: 200px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.horizontal {\n    display: flex;\n    width: 100%;\n    overflow: hidden;\n}\n\n.file-item .filename {\n    white-space: nowrap;\n    overflow: hidden;\n    width: 150px; /* Adjust width to your needs */\n}\n\n    .file-item .filename.scroll {\n        animation: scroll 5s linear infinite; /* Adjust 5s to control speed */\n    }\n\n@keyframes scroll {\n    0% {\n        transform: translateX(0);\n    }\n\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\n\n.fileicon {\n    height: 20px;\n    width: 20px;\n}\n\n.uploadRadioBtn {\n    margin-top: 20px;\n    margin-left: 10px;\n    color: var(--integration-color);\n}\n\n.hasHeadersHeader {\n    margin-top: 20px;\n    font: normal normal bold 15px/20px Segoe UI;\n    letter-spacing: 1px;\n    color: #0F3443;\n    opacity: 1;\n}\n\n.hasHeadersSubHeader {\n    margin-top: 6px;\n    font: normal normal 600 15px/20px Segoe UI;\n    color: var(--integration-light-text-color);\n    opacity: 1;\n}\n\n.radioBtnLabel {\n    font: normal normal bold 15px/20px Segoe UI;\n    letter-spacing: 1px;\n    color: #0F3443;\n    opacity: 1;\n}\n\n.uploadFileName {\n    margin-top: 15px;\n    font: normal normal 600 18px/20px Segoe UI;\n    opacity: 1;\n    color: #374151;\n    margin-bottom: 10px;\n}\n\n.uploadOptionsBoxHeader {\n    font: normal normal 600 15px/20px Segoe UI;\n    opacity: 1;\n    color: #374151;\n    margin-top: 10px;\n}\n\n.uploadOptionsBox {\n    width: 216px;\n    height: 37px;\n    margin-right: 40px;\n    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
